<div class="config-details-container p-24">
    <div class="flex flex-row justify-between items-center mb-16">
      <div class="flex flex-col">
          <div class="mat-headline-5 fw-700 mb-8">{{'SOLUTIONS.VIEW_DETAILS' | transloco }}</div>
          <div><span class="fs-14 fw-500 job-header">{{'INSTANCE_DETAILS.JOB_ID' | transloco}}: {{jobId}}</span></div>
      </div>
      <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
      </div>
      <mat-divider class="neutral-2 mb-16"></mat-divider>
      <div class="view-grid">
         <div class="grid-item">
             <span class="label fs-16 fw-600">{{ 'INSTANCE_DETAILS.SCHEDULE_ID' | transloco }}</span>
              <span class="value fs-16 fw-400 job-id" (click)="navigateToInstance()">
                {{scheduleId}}
             </span>
          </div>
          <div class="grid-item">
                <span class="label fs-16 fw-600">{{ 'INSTANCE_DETAILS.SCHEDULE_NAME' | transloco }}</span>
                <span class="value fs-16 fw-400 schedule-name">
                {{scheduleName.includes('-') ? (scheduleName.split('-')[0].trim() | titlecase) : scheduleName ? (scheduleName | titlecase) : '-'}}
             </span>
          </div>
          <div class="grid-item">
                <span class="label fs-16 fw-600">{{ 'INSTANCE_DETAILS.STATUS' | transloco }}</span>
                <div class="flex items-center status-chip" [ngClass]="scheduleStatus">
                <span><mat-icon *ngIf="scheduleStatus !== 'running' && scheduleStatus !== 'inprogress'" [svgIcon]="scheduleStatus === 'completed' ? 'check_circle' : scheduleStatus === 'failed' ? 'report_problem' :
                      scheduleStatus === 'deleted' ? 'delete' : scheduleStatus === 'disabled' ? 'block' : scheduleStatus === 'active' ? 'check_circle' : scheduleStatus === 'pending' ? 'hourglass_empty' : ''" class="icon-md p-2 mr-6" [ngClass]="scheduleStatus"></mat-icon>
                      <mat-spinner *ngIf="scheduleStatus === 'running' || scheduleStatus === 'inprogress'" diameter="16" class="mr-8"
                         color="primary"
                         mode="indeterminate">
                      </mat-spinner>
                    </span>
                <span class="value fs-16 fw-400">{{scheduleStatus}}</span>
             </div>
          </div>
        </div>
  </div>
